import { render, staticRenderFns } from "./orderTable.vue?vue&type=template&id=048beb3c&scoped=true"
import script from "./orderTable.vue?vue&type=script&lang=js"
export * from "./orderTable.vue?vue&type=script&lang=js"
import style0 from "./orderTable.vue?vue&type=style&index=0&id=048beb3c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "048beb3c",
  null
  
)

export default component.exports